var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFileLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34.4 44.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#36a6f2;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "file-link") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.2,0C.5,0,0,.5,0,1.5V44c0,.3.5.8,1.2.8h32c.6,0,1.2-.5,1.2-.8V1.5c0-1-.5-1.5-1.2-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M33.2,44.8H1.2A1.22,1.22,0,0,1,0,43.6V31.2H34.4V43.6a1.16,1.16,0,0,1-1.2,1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M23,17.72a5.49,5.49,0,0,1-7.74,0,.91.91,0,0,1,1.29-1.29h0a3.62,3.62,0,0,0,5.16,0l4.3-4.3A3.65,3.65,0,1,0,20.87,7l-4.09,4.08a.91.91,0,1,1-1.3-1.27v0l4.09-4.08a5.47,5.47,0,0,1,7.74,7.74L23,17.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M11.59,14.1a5.47,5.47,0,0,1,7.73,0A.91.91,0,1,1,18,15.39h0a3.61,3.61,0,0,0-5.15,0l-4.3,4.3a3.65,3.65,0,0,0,5.16,5.16l4.08-4.08A.91.91,0,0,1,19.13,22l0,0L15,26.14A5.47,5.47,0,0,1,7.29,18.4l4.3-4.3Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileLink);
export default __webpack_public_path__ + "static/media/file-link.e973eac29cd1f1ee123b88c4622d13a4.svg";
export { ForwardRef as ReactComponent };